module.exports = __webpack_public_path__ + "img/bg.13322baf.jpg";